function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1180 0H0V650H1180V0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_7161_73743)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M975.499 457V622.3H765.499V461.1L665.399 372.2L695.799 338L566.999 222.3H484.099L483.699 245.9L389.599 245.5V292.8L293.999 293.4V269H137.499L130.199 261.7V54.7001H389.199V79.7001L550.999 80.2001C557.299 74.8001 567.299 71.1001 584.799 69.5001C602.299 67.9001 617.999 75.4001 617.999 75.4001L621.999 52.8001C740.499 39.0001 828.399 89.2001 886.899 159.3C891.199 164.4 895.299 169.6 899.299 175C905.099 182.8 910.299 190.9 915.099 199.3C934.399 233.6 944.999 272.7 949.999 313.9C951.199 323.7 952.099 333.6 952.699 343.7C954.499 372.8 954.099 402.6 952.399 432.2L975.499 457Z",
  fill: "#FEF6F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669 206.2L666.9 218C666.4 221 663.5 223.1 660.4 222.5C660 222.4 659.6 222.3 659.2 222.1L611.5 201.5C608.2 200.1 606.7 196.2 608.1 193C608.4 192.3 608.8 191.7 609.3 191.2L619 180.7C620 179.6 621.6 179.3 623 179.9L665.2 199.1C667.9 200.3 669.5 203.2 669 206.2Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.8 146.6V166.8C524.8 171.3 521.2 175 516.6 175C516.3 175 516 175 515.7 175L492.5 172.5C487.9 172 484.5 168.1 484.5 163.6V145.7L506.1 147.6V144.2L524.8 146.6Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.2 128.6L604.8 154.6C604.1 158.8 600.1 161.6 595.9 160.9C595.5 160.8 595.2 160.7 594.8 160.6L577.3 154.9L574.2 138.8H571L569 125.1L596 117C601.5 115.4 607.2 118.5 608.9 123.9C609.3 125.4 609.4 127 609.2 128.6Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M457.8 135.2V167.6L412 170.9V132.4L457.8 135.2Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M882.498 365.7L891.298 368.2L880.598 412L871.798 409.3C871.798 409.3 839.198 408.7 837.498 408.4C835.798 408.1 817.998 387.7 829.898 374.7C841.798 361.7 847.698 376.8 882.498 365.7Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.5 79.8003C562.3 72.6003 575 68.9003 588 69.4003C607.1 70.0003 618 75.5003 618 75.5003L615.3 96.0003L564.3 111.6L560.8 94.4003L551.9 94.6003L551.5 79.8003Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M794.099 225.5L765.899 255.9L744.299 234.7L757.999 217.7L761.599 220.3L772.099 207.3L794.099 225.5Z",
  stroke: "#8B827C",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M721.1 312.8L716.1 318.4L722.4 324.4L703.7 344.3L695.9 337.8L665.5 372L765.5 460.8V622H784.6V501.7H810.8V432.8H836.4L832.5 423.6L830.1 425.8L795.2 426.3L749.3 384.9L785.3 343.7L780.6 337.6L739.6 385L708.3 356L735.8 326.1L721.1 312.8Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M636.199 240.1L629.799 236.3L621.499 246.3L616.899 243L610.499 250.7L596.199 238L591.299 243.6L626.599 275.3L643.299 256.9L630.599 246.5L636.199 240.1Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M449.699 210.2V245.4L483.899 245.6L484.199 210.5L449.699 210.2Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390 231.4L433.9 231.5V245.4L390 245.2V231.4Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M342.4 260.6H302.2H294.1L294.2 293L342.5 292.4L342.4 260.6Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.598 54.5996H337.898V86.4996H347.598V54.5996Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.198 120.4H513.798L513.398 103.5H537.198V80.2996L497.298 80.0996L496.898 103L506.198 103.5V120.4Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M647 92.8L653.7 92.5L654.3 81.6H669.9L669.4 50L645.3 50.7L645 88.1L646.8 88.6L647 92.8Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M815.598 95.3002L802.898 110.5L790.198 98.4002L782.998 106.6L764.198 90.2002L748.698 108L745.398 104.9L748.698 101.4L747.598 100.3L771.998 72.2002C787.198 78.6002 801.798 86.4002 815.598 95.3002Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M866.398 254L883.998 269.8L845.898 312.2L826.898 297.1L830.098 293.4L812.898 278L839.698 248.3L857.598 263.7L864.398 256L859.898 252.2L898.098 209.3L884.998 196.8L891.998 189.3L873.998 173.1L886.898 159.1C891.198 164.2 895.298 169.5 899.298 174.8C905.098 182.5 910.298 190.6 914.998 199.1L866.398 254Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.699 115.3L738.499 119.8L722.399 138.2L730.699 145.5L722.399 154.7L727.399 159.2L711.599 177.8L704.399 171.3L698.999 176.2L689.499 167L685.799 170.8L668.699 154.4L700.299 118.5L717.499 133.3L733.699 115.3Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M926.5 408.7L926.9 416H953L953.4 408.4L926.5 408.7Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M927.5 386.2L953.8 385.9V377.5L927.5 377.7V386.2Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M952.599 343.4L920.799 344L920.699 337.9L926.499 338.1V314.3L949.899 313.6C951.099 323.5 951.999 333.4 952.599 343.4Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M881.299 543.3L888.799 541.9V608.2H915.599V622H880.299L881.299 543.3Z",
  fill: "#EDECE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M889.998 458.1L855.998 457.9C855.598 453.3 852.898 446.9 850.598 443.5C847.998 439.6 849.498 425.9 859.298 426C859.298 426 873.998 425.6 877.898 426C883.398 426.7 887.498 431.2 887.798 436.7C888.098 440.8 889.098 449.9 889.998 458.1Z",
  fill: "#FC8B52",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M389.899 220.6V245.4H389.699V292.7H342.399V283.3L342.299 260.9L342.199 220.6H389.899Z",
  fill: "#BA7BBA",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M342.3 260.9H319V220.6H342.2L342.3 260.9Z",
  fill: "#BA7BBA",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M364.8 220.6H319V197.1H364.2V196.9L364.8 220.6Z",
  fill: "#BA7BBA",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M743.498 130.8L730.698 145.8L722.398 138.6L738.498 120.1L743.098 124.2C744.998 125.9 745.198 128.8 743.498 130.8Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M898.199 209.4L856.699 255.9L848.399 248.7L855.099 241.8V239.3L889.399 201.1L885.099 197L882.799 199.5L866.999 185.5L866.699 183.8L863.999 181.5L872.199 171.9L891.999 189.6L873.999 173.4L886.799 159.6C873.799 143.9 859.199 129.5 843.399 116.6C834.399 109.2 824.899 102.3 815.099 96L802.699 110.8L803.599 111.6L796.699 119.2L782.999 107L772.199 97.6L759.999 111.6C758.399 113.5 755.499 113.7 753.599 112.1L753.499 112L748.999 107.9L738.499 120L743.099 124.1C744.999 125.8 745.199 128.8 743.499 130.7L730.699 145.7L729.799 146.7L722.299 154.9L727.299 159.4L737.199 148.9L755.799 165.7L749.799 172.3C750.199 172.6 776.599 189.1 790.599 203.2C804.599 217.3 818.699 234.1 818.699 234.1L824.499 227.5L843.299 244.5L839.599 248.5L857.499 263.9L864.299 256.2L859.799 252.4L898.199 209.4ZM827.899 180.6L823.599 185.4C822.299 186.8 820.199 186.9 818.799 185.7L797.099 166.5C795.599 165.1 795.399 162.8 796.799 161.3C796.799 161.2 796.899 161.2 796.899 161.1L801.499 156.5C802.599 155.4 804.299 155.4 805.399 156.4L827.499 175.5C829.099 176.6 829.299 179 827.899 180.6C827.899 180.5 827.899 180.5 827.899 180.6Z",
  fill: "#FDC232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.899 180.6L823.599 185.4C822.299 186.8 820.199 186.9 818.799 185.7L797.099 166.5C795.599 165.1 795.399 162.8 796.799 161.3C796.799 161.2 796.899 161.2 796.899 161.1L801.499 156.5C802.599 155.4 804.299 155.4 805.399 156.4L827.499 175.5C829.099 176.6 829.299 179 827.899 180.6ZM827.899 180.6C827.899 180.5 827.899 180.5 827.899 180.6ZM898.199 209.4L856.699 255.9L848.399 248.7L855.099 241.8V239.3L889.399 201.1L885.099 197L882.799 199.5L866.999 185.5L866.699 183.8L863.999 181.5L872.199 171.9L891.999 189.6L873.999 173.4L886.799 159.6C873.799 143.9 859.199 129.5 843.399 116.6C834.399 109.2 824.899 102.3 815.099 96L802.699 110.8L803.599 111.6L796.699 119.2L782.999 107L772.199 97.6L759.999 111.6C758.399 113.5 755.499 113.7 753.599 112.1L753.499 112L748.999 107.9L738.499 120L743.099 124.1C744.999 125.8 745.199 128.8 743.499 130.7L730.699 145.7L729.799 146.7L722.299 154.9L727.299 159.4L737.199 148.9L755.799 165.7L749.799 172.3C750.199 172.6 776.599 189.1 790.599 203.2C804.599 217.3 818.699 234.1 818.699 234.1L824.499 227.5L843.299 244.5L839.599 248.5L857.499 263.9L864.299 256.2L859.799 252.4L898.199 209.4Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M772.3 97.5996L760.1 111.6C758.5 113.5 755.6 113.7 753.7 112.1L753.6 112L749.1 107.9L764.2 90.5996L772.3 97.5996Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.899 180.6L823.599 185.4C822.299 186.8 820.199 186.9 818.799 185.7L797.099 166.5C795.599 165.1 795.399 162.8 796.799 161.3C796.799 161.2 796.899 161.2 796.899 161.1L801.499 156.5C802.599 155.4 804.299 155.4 805.399 156.4L827.499 175.5C829.099 176.6 829.299 179 827.899 180.6C827.899 180.5 827.899 180.5 827.899 180.6Z",
  fill: "#FDC232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M827.899 180.6L823.599 185.4C822.299 186.8 820.199 186.9 818.799 185.7L797.099 166.5C795.599 165.1 795.399 162.8 796.799 161.3C796.799 161.2 796.899 161.2 796.899 161.1L801.499 156.5C802.599 155.4 804.299 155.4 805.399 156.4L827.499 175.5C829.099 176.6 829.299 179 827.899 180.6ZM827.899 180.6C827.899 180.5 827.899 180.5 827.899 180.6Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M803.8 111.6L796.9 119.2L783 106.9L790.2 98.7002L802.8 110.9L802.9 110.8L803.8 111.6Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M755.798 165.8L749.798 172.3L746.098 176.4L727.398 159.4L737.298 149L755.798 165.8Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M843.3 244.5L839.7 248.5L834.4 254.2L815.5 237.8L818.7 234.1L824.5 227.5L843.3 244.5Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M898.2 209.4L856.8 255.9L848.5 248.8L855.2 241.8L855.1 239.3L889.4 201.1L898.2 209.4Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M892 189.6L885.1 197.1L882.8 199.5L867 185.5L866.7 183.8L864.1 181.5L872.2 171.9L892 189.6Z",
  fill: "#FDC232",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M750.899 188.5L727.299 216.7C722.799 222 717.599 220.6 713.099 217.6C708.599 214.6 673.799 193.4 668.599 190.7L668.099 190.4L667.299 190L689.599 167.2L699.099 176.4L704.499 171.5L729.999 194.5L738.399 185.5L743.799 190.4L747.399 185.5L750.899 188.5Z",
  stroke: "white",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.999 191L294.099 269.1H137.499L130.199 261.8V54.7998H310.099L310.399 91.3998L259.399 90.9998V130.9C254.799 131.9 251.599 136 251.599 140.7L252.199 181.2C252.299 186.6 256.699 191 262.099 191H293.999Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.999 191L294.099 269.1H137.499L130.199 261.8V54.7998H310.099L310.399 91.3998L259.399 90.9998V130.9C254.799 131.9 251.599 136 251.599 140.7L252.199 181.2C252.299 186.6 256.699 191 262.099 191H293.999Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M975.499 457V622.3H915.599V608.5H888.799V542.2C922.499 528.8 905.199 490.7 901.499 478.1C897.799 465.5 894.499 425.9 897.599 398.4L919.999 397.9V409.6L926.499 409L926.899 416.3H952.899C952.699 421.6 952.499 427 952.299 432.3L975.499 457Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M975.499 457V622.3H915.599V608.5H888.799V542.2C922.499 528.8 905.199 490.7 901.499 478.1C897.799 465.5 894.499 425.9 897.599 398.4L919.999 397.9V409.6L926.499 409L926.899 416.3H952.899C952.699 421.6 952.499 427 952.299 432.3L975.499 457Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M700.6 104.8V119L700.3 118.7L668.8 154.6L685.9 171L689.6 167.3L667.2 190C665.1 188.9 661.9 187.2 658.1 185.1L657.7 184.9L657 184.5L656.4 184.2C654.4 183.2 652.3 182.1 650.1 181C649.7 180.8 649.2 180.6 648.8 180.3C646.3 179.1 643.7 177.8 641.2 176.7L640.1 176.2L638.7 175.6L638 175.3C635.6 174.3 633.3 173.4 631.2 172.7L630.6 172.5L629.5 172.1C617 168.3 614.7 161.8 616.1 152.3C616.1 152.3 618.8 134 620.9 122.7C623 111.4 632.1 103.1 645.6 101.8C654.2 101.1 678.6 101.2 700.6 104.8Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700.6 104.8V119L700.3 118.7L668.8 154.6L685.9 171L689.6 167.3L667.2 190C665.1 188.9 661.9 187.2 658.1 185.1L657.7 184.9L657 184.5L656.4 184.2C654.4 183.2 652.3 182.1 650.1 181C649.7 180.8 649.2 180.6 648.8 180.3C646.3 179.1 643.7 177.8 641.2 176.7L640.1 176.2L638.7 175.6L638 175.3C635.6 174.3 633.3 173.4 631.2 172.7L630.6 172.5L629.5 172.1C617 168.3 614.7 161.8 616.1 152.3C616.1 152.3 618.8 134 620.9 122.7C623 111.4 632.1 103.1 645.6 101.8C654.2 101.1 678.6 101.2 700.6 104.8Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M881.3 543.6L880.3 622.3H784.6V502H810.8V433H836.4C836.4 433 844.9 451.1 846.7 458.1C848.5 465.1 842.1 492.3 839.4 497.9C835.2 506.5 832.7 528.7 850.4 538.8C857.3 542.8 867.2 544.8 881.3 543.6Z",
  fill: "#FC965C",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.499 100.6L748.599 101.7L745.299 105.2C742.999 102.5 740.199 100.3 737.099 98.8004C731.999 96.4004 708.599 96.9004 700.299 95.7004C699.099 95.5004 697.499 95.3004 695.699 95.1004V52.4004C718.299 55.3004 744.499 60.8004 771.999 72.4004L747.499 100.6Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M646.999 88.4998V92.9998L615.299 95.9998L617.899 75.6998L621.899 52.7998C629.599 51.4998 637.399 50.5998 645.199 50.2998L644.999 88.2998L646.999 88.4998Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M646.999 88.4998V92.9998L615.299 95.9998L617.899 75.6998L621.899 52.7998C629.599 51.4998 637.399 50.5998 645.199 50.2998L644.999 88.2998L646.999 88.4998Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.6 50C677.472 50.2922 686.478 51.2432 695.699 52.4004C695.712 52.4021 695.725 52.4036 695.738 52.4053C695.992 52.4371 696.246 52.4678 696.5 52.5L696.499 52.5049C718.916 55.4317 744.823 60.937 771.999 72.4004L747.499 100.601L748.6 101.7L745.299 105.2C742.999 102.5 740.199 100.301 737.1 98.8008C732 96.4008 708.599 96.9002 700.299 95.7002C699.099 95.5002 697.499 95.3006 695.699 95.1006V94.9707C684.625 93.8747 664.108 92.5947 654 92.5947L654.5 81.7705H670.1L669.6 50Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M832.499 423.9L830.099 426.1L795.199 426.6L749.299 385.2L785.299 344C805.399 367.8 828.299 414.2 832.499 423.9Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M832.499 423.9L830.099 426.1L795.199 426.6L749.299 385.2L785.299 344C805.399 367.8 828.299 414.2 832.499 423.9Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M780.599 337.9L739.499 385.3L708.199 356.3L735.699 326.3L753.699 306.7C753.799 306.7 770.899 325.4 780.599 337.9Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M780.599 337.9L739.499 385.3L708.199 356.3L735.699 326.3L753.699 306.7C753.799 306.7 770.899 325.4 780.599 337.9Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.7 115.5L717.6 133.5L700.6 119V104.8C713.8 106.9 726.1 110.3 733.7 115.5Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.7 115.5L717.6 133.5L700.6 119V104.8C713.8 106.9 726.1 110.3 733.7 115.5Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M750.899 188.5L727.299 216.7C722.799 222 717.599 220.6 713.099 217.6C708.599 214.6 673.799 193.4 668.599 190.7L668.099 190.4L667.299 190L689.599 167.2L699.099 176.4L704.499 171.5L729.999 194.5L738.399 185.5L743.799 190.4L747.399 185.5L750.899 188.5Z",
  fill: "#B0ACD2",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M530.7 144.1L503.6 140.6L503.4 143.7L481 142.3V132.3C481 132.3 498.9 133.4 509.9 132.3C520.9 131.2 526.9 129.5 529.3 132.9C531.7 136.3 530.7 144.1 530.7 144.1Z",
  fill: "#B0ACD2",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M389.199 54.7998V79.6998H387.899V116C379.799 114.5 372.099 112.9 365.299 111.3V54.7998H389.199Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.199 54.7998V79.6998H387.899V116C379.799 114.5 372.099 112.9 365.299 111.3V54.7998H389.199Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.199 80.1996V123.1C476.999 122.9 469.399 122.6 459.799 122.5L459.299 80.0996L483.199 80.1996Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483.199 80.1996V123.1C476.999 122.9 469.399 122.6 459.799 122.5L459.299 80.0996L483.199 80.1996Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M949.899 314.3L926.499 314.7V338.5L920.699 338.3L921.699 389.3H909.999C909.999 389.3 901.199 389.7 901.399 383.1C901.499 380.5 902.399 372.6 903.499 364.1C904.699 354.2 897.699 345.2 887.899 344C885.499 343.7 882.999 343.9 880.599 344.6L839.599 356.7C826.999 360.4 813.299 355.8 805.599 345.1C802.699 341.1 798.999 336.4 796.299 332.9L795.699 332.1C795.399 331.6 794.999 331.2 794.699 330.8C789.999 324.7 777.299 309.9 767.499 298.6C760.399 290.3 760.699 278.1 768.199 270.1L802.599 233.6L811.599 241.7L798.799 256L817.399 272.9L812.899 278.2L830.099 293.6L827.099 297.1L845.899 312.4L883.999 270L866.399 254.2L914.499 200C934.499 235.8 944.999 273.9 949.899 314.3Z",
  fill: "#FC8B52",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M571.699 155.8L545.899 151.2C543.199 150.7 541.199 148.4 540.999 145.7L540.299 133.3C540.099 130.1 542.399 127.3 545.599 126.8C552.599 125.6 559.399 123.6 565.899 120.8L571.699 155.8Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M571.699 155.8L545.899 151.2C543.199 150.7 541.199 148.4 540.999 145.7L540.299 133.3C540.099 130.1 542.399 127.3 545.599 126.8C552.599 125.6 559.399 123.6 565.899 120.8L571.699 155.8Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M438.199 185.4V205H389.899V220.6H364.799L364.199 196.9L364.299 192.6C364.399 190.5 365.899 188.7 367.999 188.3C378.499 186.3 409.699 180.5 431.999 179.5C435.299 179.4 437.999 181.9 438.199 185.2C438.199 185.3 438.199 185.4 438.199 185.4Z",
  fill: "#B0ACD2",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M577.098 197.7V211L566.998 222.3H529.398V193.4H534.398V186.8C548.798 189.6 563.098 193.2 577.098 197.7Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.098 197.7V211L566.998 222.3H529.398V193.4H534.398V186.8C548.798 189.6 563.098 193.2 577.098 197.7Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M484.1 210.8L449.6 210.5V184C449.6 181.2 451.8 179 454.6 178.9C464.7 178.9 474.4 179.3 483.8 180L484.1 210.8Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.1 210.8L449.6 210.5V184C449.6 181.2 451.8 179 454.6 178.9C464.7 178.9 474.4 179.3 483.8 180L484.1 210.8Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.399 193.3V222.2H484.099V214.1V210.7L483.799 179.8C497.799 180.8 510.999 182.5 522.999 184.6V193.3H529.399Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529.399 193.3V222.2H484.099V214.1V210.7L483.799 179.8C497.799 180.8 510.999 182.5 522.999 184.6V193.3H529.399Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M632.1 233.8L621.4 246.5L616.8 243.2L610.4 251L596.2 238.2L591.2 243.8L567.2 222.2H567L577.1 210.9V197.6C588.4 201.3 595.2 204.2 596 204.8C598.7 206.8 600.7 217.2 602.5 219.8C604.3 222.4 622.4 227.9 632.1 233.8Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M632.1 233.8L621.4 246.5L616.8 243.2L610.4 251L596.2 238.2L591.2 243.8L567.2 222.2H567L577.1 210.9V197.6C588.4 201.3 595.2 204.2 596 204.8C598.7 206.8 600.7 217.2 602.5 219.8C604.3 222.4 622.4 227.9 632.1 233.8Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.5 247.8L644.5 291.7L626.5 275.6L643.2 257.2L630.5 246.8L638.8 237.4C644.3 242.5 654.7 234.3 659.9 234.8C662.5 235 673.3 241.2 683.5 247.8Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M683.5 247.8L644.5 291.7L626.5 275.6L643.2 257.2L630.5 246.8L638.8 237.4C644.3 242.5 654.7 234.3 659.9 234.8C662.5 235 673.3 241.2 683.5 247.8Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M697.1 305.4C694.9 310 685.2 319.2 680.3 323.7L644.6 291.6L683.5 247.7V247.6C693.2 253.9 702.3 260.5 703 262.5C704.2 266.8 700.1 299.2 697.1 305.4Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697.1 305.4C694.9 310 685.2 319.2 680.3 323.7L644.6 291.6L683.5 247.7V247.6C693.2 253.9 702.3 260.5 703 262.5C704.2 266.8 700.1 299.2 697.1 305.4Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.398 91.3V86.8L321.798 86.5V123.9C321.798 127.6 318.798 130.6 315.098 130.6H261.598C260.898 130.6 260.098 130.7 259.398 130.8V91L310.398 91.3Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.398 91.3V86.8L321.798 86.5V123.9C321.798 127.6 318.798 130.6 315.098 130.6H261.598C260.898 130.6 260.098 130.7 259.398 130.8V91L310.398 91.3Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.198 54.7998V111.4C348.798 107.7 337.398 104.6 337.398 104.6V86.5998H347.498V54.7998H365.198Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.198 54.7998V111.4C348.798 107.7 337.398 104.6 337.398 104.6V86.5998H347.498V54.7998H365.198Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.898 79.8002V120C404.498 118.9 395.998 117.5 387.898 116V79.7002H389.198L411.098 79.8002H412.898Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.898 79.8002V120C404.498 118.9 395.998 117.5 387.898 116V79.7002H389.198L411.098 79.8002H412.898Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.099 103.6V123.3C503.099 124.1 496.899 123.7 483.199 123.1V80.2002L497.299 80.3002L496.899 103.2L506.099 103.6Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.099 103.6V123.3C503.099 124.1 496.899 123.7 483.199 123.1V80.2002L497.299 80.3002L496.899 103.2L506.099 103.6Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M459.798 122.5C454.998 122.4 449.798 122.4 444.098 122.3C433.698 122.2 423.198 121.4 412.898 120V79.7998L459.398 79.9998L459.798 122.5Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459.798 122.5C454.998 122.4 449.798 122.4 444.098 122.3C433.698 122.2 423.198 121.4 412.898 120V79.7998L459.398 79.9998L459.798 122.5Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.299 103.7V120.6C524.199 121.7 518.399 122.4 513.799 122.8L513.299 103.7H530.299Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.299 103.7V120.6C524.199 121.7 518.399 122.4 513.799 122.8L513.299 103.7H530.299Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.299 111.7C557.099 115.1 542.999 118.5 530.299 120.7V103.8H537.099V80.4998L550.499 80.5998C550.499 80.5998 550.799 80.2998 551.499 79.7998L551.899 94.6998L560.799 94.4998L564.299 111.7Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.299 111.7C557.099 115.1 542.999 118.5 530.299 120.7V103.8H537.099V80.4998L550.499 80.5998C550.499 80.5998 550.799 80.2998 551.499 79.7998L551.899 94.6998L560.799 94.4998L564.299 111.7Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.798 306.7L735.798 326.3L711.198 304.1C707.898 295.4 725.598 291.9 733.298 290.8C735.698 290.5 738.098 291.2 739.898 292.9C744.898 297.5 753.798 306.7 753.798 306.7Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.798 306.7L735.798 326.3L711.198 304.1C707.898 295.4 725.598 291.9 733.298 290.8C735.698 290.5 738.098 291.2 739.898 292.9C744.898 297.5 753.798 306.7 753.798 306.7Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.999 149.3L365.699 149.4V119.8C367.999 120.3 370.099 120.7 371.699 120.9C376.299 121.6 381.899 122.5 386.499 123.2C391.799 124 395.699 128.6 395.799 133.9L395.999 149.3Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.999 149.3L365.699 149.4V119.8C367.999 120.3 370.099 120.7 371.699 120.9C376.299 121.6 381.899 122.5 386.499 123.2C391.799 124 395.699 128.6 395.799 133.9L395.999 149.3Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.699 119.8V149.4L333.699 149.5L333.899 124.7C333.999 119.1 338.499 114.6 344.099 114.7C344.899 114.7 345.799 114.8 346.599 115C352.799 116.7 360.099 118.6 365.699 119.8Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.699 119.8V149.4L333.699 149.5L333.899 124.7C333.999 119.1 338.499 114.6 344.099 114.7C344.899 114.7 345.799 114.8 346.599 115C352.799 116.7 360.099 118.6 365.699 119.8Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.698 149.5V180.8L346.898 183.8C340.598 184.8 334.598 180.5 333.598 174.2C333.498 173.5 333.398 172.9 333.498 172.2L333.698 149.6L365.698 149.5Z",
  fill: "#FDC232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.698 149.5V180.8L346.898 183.8C340.598 184.8 334.598 180.5 333.598 174.2C333.498 173.5 333.398 172.9 333.498 172.2L333.698 149.6L365.698 149.5Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.299 165.9C396.399 171.6 392.299 176.6 386.599 177.5L365.699 180.8V149.5L395.999 149.4L396.299 165.9Z",
  fill: "#FC965C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.299 165.9C396.399 171.6 392.299 176.6 386.599 177.5L365.699 180.8V149.5L395.999 149.4L396.299 165.9Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M593.7 178.2L592.6 185.1C592 188.7 588.6 191.2 584.9 190.6C584.6 190.5 584.3 190.5 584 190.4C577.9 188.5 569.6 185.9 565.1 184.6L571 164C577 165.4 583 167 587.8 168.5C591.9 169.9 594.4 174 593.7 178.2Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593.7 178.2L592.6 185.1C592 188.7 588.6 191.2 584.9 190.6C584.6 190.5 584.3 190.5 584 190.4C577.9 188.5 569.6 185.9 565.1 184.6L571 164C577 165.4 583 167 587.8 168.5C591.9 169.9 594.4 174 593.7 178.2Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M571.099 164.1L565.199 184.7L564.999 184.6C560.499 183.3 552.799 181.9 547.299 180.9C543.599 180.3 540.899 177 540.999 173.3L541.099 164.6C541.099 161.4 543.699 158.9 546.899 159C547.199 159 547.599 159 547.899 159.1C553.699 160.2 562.499 162 571.099 164.1Z",
  fill: "#BFDBE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M571.099 164.1L565.199 184.7L564.999 184.6C560.499 183.3 552.799 181.9 547.299 180.9C543.599 180.3 540.899 177 540.999 173.3L541.099 164.6C541.099 161.4 543.699 158.9 546.899 159C547.199 159 547.599 159 547.899 159.1C553.699 160.2 562.499 162 571.099 164.1Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M713 235.7L705.2 245.5C703.3 247.8 700 248.4 697.5 246.7L680.8 235.6C678.2 233.9 677 230.7 677.9 227.7C678.3 226.2 678.7 224.5 679.1 222.7C679.4 220.9 679.6 219 679.8 217.1C680 213.9 682.8 211.5 686 211.7C687 211.8 687.9 212.1 688.8 212.6L711.8 227.6C714.3 229.3 715 232.7 713.3 235.3C713.2 235.5 713.1 235.6 713 235.7Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M713 235.7L705.2 245.5C703.3 247.8 700 248.4 697.5 246.7L680.8 235.6C678.2 233.9 677 230.7 677.9 227.7C678.3 226.2 678.7 224.5 679.1 222.7C679.4 220.9 679.6 219 679.8 217.1C680 213.9 682.8 211.5 686 211.7C687 211.8 687.9 212.1 688.8 212.6L711.8 227.6C714.3 229.3 715 232.7 713.3 235.3C713.2 235.5 713.1 235.6 713 235.7Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M753 268.9L745 277.2C742.8 279.5 739.2 279.7 736.8 277.7L713.5 258.5C711.1 256.6 710.8 253.1 712.7 250.7L720.4 241.1C722.4 238.6 726.1 238.2 728.7 240.2C728.7 240.2 728.8 240.2 728.8 240.3L752.7 260.3C755.2 262.4 755.5 266.1 753.4 268.6C753.2 268.7 753.2 268.8 753 268.9Z",
  fill: "#B0ACD2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753 268.9L745 277.2C742.8 279.5 739.2 279.7 736.8 277.7L713.5 258.5C711.1 256.6 710.8 253.1 712.7 250.7L720.4 241.1C722.4 238.6 726.1 238.2 728.7 240.2C728.7 240.2 728.8 240.2 728.8 240.3L752.7 260.3C755.2 262.4 755.5 266.1 753.4 268.6C753.2 268.7 753.2 268.8 753 268.9Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M816.298 101L799.398 121.4L861.598 179.2L881.598 158.3C881.598 158.3 861.398 136.9 850.098 126.6C837.798 115.4 816.298 101 816.298 101Z",
  fill: "#FD9E06",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M908.199 501.6H975.399",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M850.398 538.8V566.2H784.898",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M400.5 182.8V205",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 259,
  y: 141,
  width: 61,
  height: 41,
  rx: 10,
  fill: "#FC965C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M278.65 164V156.727H280.187V159.934H280.283L282.9 156.727H284.743L282.045 159.984L284.775 164H282.936L280.944 161.01L280.187 161.933V164H278.65ZM285.544 164V156.727H287.082V159.728H290.203V156.727H291.737V164H290.203V160.996H287.082V164H285.544ZM297.497 156.727H299.035V161.45C299.035 161.981 298.908 162.445 298.655 162.842C298.404 163.24 298.052 163.55 297.6 163.773C297.148 163.993 296.621 164.103 296.02 164.103C295.416 164.103 294.888 163.993 294.436 163.773C293.984 163.55 293.633 163.24 293.382 162.842C293.131 162.445 293.005 161.981 293.005 161.45V156.727H294.543V161.319C294.543 161.596 294.603 161.842 294.724 162.058C294.847 162.273 295.02 162.442 295.242 162.565C295.465 162.688 295.724 162.75 296.02 162.75C296.318 162.75 296.578 162.688 296.798 162.565C297.02 162.442 297.192 162.273 297.313 162.058C297.436 161.842 297.497 161.596 297.497 161.319V156.727ZM269.041 168.727L270.799 174.253H270.866L272.627 168.727H274.332L271.825 176H269.843L267.333 168.727H269.041ZM279.699 168.727H281.237V173.45C281.237 173.981 281.11 174.445 280.857 174.842C280.606 175.24 280.255 175.55 279.802 175.773C279.35 175.993 278.824 176.103 278.222 176.103C277.619 176.103 277.091 175.993 276.638 175.773C276.186 175.55 275.835 175.24 275.584 174.842C275.333 174.445 275.207 173.981 275.207 173.45V168.727H276.745V173.319C276.745 173.596 276.805 173.842 276.926 174.058C277.049 174.273 277.222 174.442 277.445 174.565C277.667 174.688 277.926 174.75 278.222 174.75C278.521 174.75 278.78 174.688 279 174.565C279.222 174.442 279.394 174.273 279.515 174.058C279.638 173.842 279.699 173.596 279.699 173.319V168.727ZM284.04 168.727V176H282.502V168.727H284.04ZM294.036 171.273H292.481C292.453 171.072 292.395 170.893 292.307 170.737C292.219 170.579 292.107 170.444 291.97 170.332C291.832 170.221 291.674 170.136 291.494 170.077C291.316 170.018 291.123 169.988 290.915 169.988C290.538 169.988 290.211 170.081 289.931 170.268C289.652 170.453 289.435 170.723 289.281 171.078C289.127 171.431 289.051 171.859 289.051 172.364C289.051 172.882 289.127 173.318 289.281 173.67C289.438 174.023 289.655 174.29 289.935 174.469C290.214 174.649 290.537 174.739 290.904 174.739C291.11 174.739 291.301 174.712 291.476 174.658C291.653 174.603 291.811 174.524 291.948 174.42C292.086 174.313 292.199 174.184 292.289 174.033C292.381 173.881 292.445 173.708 292.481 173.514L294.036 173.521C293.996 173.855 293.895 174.177 293.734 174.487C293.576 174.795 293.362 175.071 293.092 175.315C292.824 175.556 292.505 175.748 292.133 175.89C291.764 176.03 291.346 176.099 290.879 176.099C290.231 176.099 289.651 175.953 289.139 175.659C288.63 175.366 288.228 174.941 287.932 174.384C287.638 173.828 287.492 173.154 287.492 172.364C287.492 171.571 287.641 170.896 287.939 170.339C288.237 169.783 288.642 169.359 289.153 169.068C289.665 168.775 290.24 168.628 290.879 168.628C291.301 168.628 291.691 168.687 292.051 168.805C292.413 168.924 292.734 169.097 293.014 169.324C293.293 169.549 293.52 169.825 293.695 170.151C293.873 170.478 293.987 170.852 294.036 171.273ZM295.139 176V168.727H296.677V171.728H299.798V168.727H301.332V176H299.798V172.996H296.677V176H295.139ZM309.003 168.372H309.976C309.976 169.063 309.825 169.6 309.525 169.981C309.224 170.362 308.748 170.553 308.097 170.553V169.771C308.443 169.771 308.679 169.648 308.807 169.402C308.937 169.156 309.003 168.812 309.003 168.372ZM309.283 172.364C309.283 173.157 309.133 173.831 308.832 174.388C308.534 174.944 308.127 175.369 307.611 175.663C307.097 175.954 306.519 176.099 305.878 176.099C305.231 176.099 304.651 175.953 304.138 175.659C303.624 175.366 303.218 174.941 302.919 174.384C302.621 173.828 302.472 173.154 302.472 172.364C302.472 171.571 302.621 170.896 302.919 170.339C303.218 169.783 303.624 169.359 304.138 169.068C304.651 168.775 305.231 168.628 305.878 168.628C306.519 168.628 307.097 168.775 307.611 169.068C308.127 169.359 308.534 169.783 308.832 170.339C309.133 170.896 309.283 171.571 309.283 172.364ZM307.724 172.364C307.724 171.85 307.647 171.417 307.493 171.064C307.342 170.711 307.128 170.444 306.851 170.261C306.574 170.079 306.249 169.988 305.878 169.988C305.506 169.988 305.182 170.079 304.905 170.261C304.628 170.444 304.412 170.711 304.258 171.064C304.107 171.417 304.031 171.85 304.031 172.364C304.031 172.877 304.107 173.311 304.258 173.663C304.412 174.016 304.628 174.284 304.905 174.466C305.182 174.648 305.506 174.739 305.878 174.739C306.249 174.739 306.574 174.648 306.851 174.466C307.128 174.284 307.342 174.016 307.493 173.663C307.647 173.311 307.724 172.877 307.724 172.364ZM312.272 168.727V176H310.735V168.727H312.272Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7161_73743"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1180,
  height: 650,
  fill: "white"
})));

function SvgMapF3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1180,
    height: 650,
    viewBox: "0 0 1180 650",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7161_73743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7161_73743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1180,
    height: 650
  }, _ref2), _ref3, _ref4, _ref5), _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapF3);
export default __webpack_public_path__ + "static/media/map_f3.1336b822.svg";
export { ForwardRef as ReactComponent };